import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../App.css"; // Shared CSS for consistent styling

const RegistrationForm = () => {
    const [plan, setPlan] = useState("");
    const [formFields, setFormFields] = useState({});
    const [confirmEmail, setConfirmEmail] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        const selectedPlan = localStorage.getItem("selectedPlan");
        setPlan(selectedPlan || "Free Plan");
    }, []);

    const handleFieldChange = (e) => {
        const { name, value } = e.target;
        setFormFields((prev) => ({ ...prev, [name]: value }));
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        setError("");

        if (formFields.email !== confirmEmail) {
            setError("Email addresses do not match.");
            return;
        }

        if (formFields.password !== confirmPassword) {
            setError("Passwords do not match.");
            return;
        }

        if (plan === "Free Plan") {
            navigate("/personal-dashboard");
        } else if (plan === "School/Educational Plan") {
            navigate("/school-dashboard");
        } else {
            alert("Registration complete!");
            navigate("/login");
        }
    };

    return (
        <div
            className="page-container"
            style={{
                backgroundImage: `url(${require("../assets/images/landing_background.jpg")})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                minHeight: "100vh",
                fontFamily: "Montserrat, sans-serif",
            }}
        >
            {/* Header */}
            <header
                className="page-header"
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "10px 20px",
                    backgroundColor: "rgba(0, 0, 0, 0.8)",
                    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.5)",
                }}
            >
                <img
                    src={require("../assets/images/logo_name.PNG")}
                    alt="YourStoryWorld Logo"
                    style={{ height: "50px", cursor: "pointer" }}
                    onClick={() => navigate("/")}
                />
                <nav style={{ display: "flex", gap: "15px" }}>
                    <button onClick={() => navigate("/")} className="header-button">
                        Home
                    </button>
                    <button onClick={() => navigate("/help")} className="header-button">
                        Help
                    </button>
                </nav>
            </header>

            {/* Main Content */}
            <main
                className="page-content"
                style={{ textAlign: "center", padding: "20px", marginTop: "30px" }}
            >
                <div
                    style={{
                        background: "rgba(255, 255, 255, 0.95)",
                        padding: "30px",
                        borderRadius: "10px",
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        width: "90%",
                        maxWidth: "600px",
                        margin: "0 auto",
                    }}
                >
                    <h1
                        style={{
                            color: "#007BFF",
                            fontSize: "32px",
                            fontWeight: "bold",
                            marginBottom: "20px",
                        }}
                    >
                        Register for {plan}
                    </h1>
                    {error && (
                        <p style={{ color: "red", marginBottom: "10px" }}>{error}</p>
                    )}
                    <form onSubmit={handleSubmit}>
                        {/* Dynamically Rendered Fields */}
                        {plan === "School/Educational Plan" && (
                            <>
                                <div className="form-group" style={{ marginBottom: "20px" }}>
                                    <label>School Name:</label>
                                    <input
                                        type="text"
                                        name="schoolName"
                                        value={formFields.schoolName || ""}
                                        onChange={handleFieldChange}
                                        required
                                        className="form-input"
                                    />
                                </div>
                                <div className="form-group" style={{ marginBottom: "20px" }}>
                                    <label>School Address:</label>
                                    <input
                                        type="text"
                                        name="schoolAddress"
                                        value={formFields.schoolAddress || ""}
                                        onChange={handleFieldChange}
                                        required
                                        className="form-input"
                                    />
                                </div>
                                <div className="form-group" style={{ marginBottom: "20px" }}>
                                    <label>VAT Number:</label>
                                    <input
                                        type="text"
                                        name="vatNumber"
                                        value={formFields.vatNumber || ""}
                                        onChange={handleFieldChange}
                                        className="form-input"
                                    />
                                </div>
                                <div className="form-group" style={{ marginBottom: "20px" }}>
                                    <label>Phone Number:</label>
                                    <input
                                        type="text"
                                        name="phoneNumber"
                                        value={formFields.phoneNumber || ""}
                                        onChange={handleFieldChange}
                                        required
                                        className="form-input"
                                    />
                                </div>
                                <div className="form-group" style={{ marginBottom: "20px" }}>
                                    <label>Contact Name:</label>
                                    <input
                                        type="text"
                                        name="contactName"
                                        value={formFields.contactName || ""}
                                        onChange={handleFieldChange}
                                        required
                                        className="form-input"
                                    />
                                </div>
                            </>
                        )}

                        {plan !== "School/Educational Plan" && (
                            <>
                                <div className="form-group" style={{ marginBottom: "20px" }}>
                                    <label>Title:</label>
                                    <select
                                        name="title"
                                        value={formFields.title || ""}
                                        onChange={handleFieldChange}
                                        required
                                        className="form-input"
                                    >
                                        <option value="">-- Select --</option>
                                        <option value="Mr">Mr</option>
                                        <option value="Ms">Ms</option>
                                        <option value="Mrs">Mrs</option>
                                        <option value="Dr">Dr</option>
                                    </select>
                                </div>
                                <div className="form-group" style={{ marginBottom: "20px" }}>
                                    <label>First Name:</label>
                                    <input
                                        type="text"
                                        name="firstName"
                                        value={formFields.firstName || ""}
                                        onChange={handleFieldChange}
                                        required
                                        className="form-input"
                                    />
                                </div>
                                <div className="form-group" style={{ marginBottom: "20px" }}>
                                    <label>Last Name:</label>
                                    <input
                                        type="text"
                                        name="lastName"
                                        value={formFields.lastName || ""}
                                        onChange={handleFieldChange}
                                        required
                                        className="form-input"
                                    />
                                </div>
                            </>
                        )}

                        <div className="form-group" style={{ marginBottom: "20px" }}>
                            <label>Email Address:</label>
                            <input
                                type="email"
                                name="email"
                                value={formFields.email || ""}
                                onChange={handleFieldChange}
                                required
                                className="form-input"
                            />
                        </div>
                        <div className="form-group" style={{ marginBottom: "20px" }}>
                            <label>Confirm Email Address:</label>
                            <input
                                type="email"
                                value={confirmEmail}
                                onChange={(e) => setConfirmEmail(e.target.value)}
                                required
                                className="form-input"
                            />
                        </div>
                        <div className="form-group" style={{ marginBottom: "20px" }}>
                            <label>Password:</label>
                            <input
                                type="password"
                                name="password"
                                value={formFields.password || ""}
                                onChange={handleFieldChange}
                                required
                                className="form-input"
                            />
                        </div>
                        <div className="form-group" style={{ marginBottom: "20px" }}>
                            <label>Confirm Password:</label>
                            <input
                                type="password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                required
                                className="form-input"
                            />
                        </div>

                        <button
                            type="submit"
                            className="submit-button"
                            style={{
                                width: "100%",
                                padding: "10px",
                                backgroundColor: "#007BFF",
                                color: "white",
                                border: "none",
                                borderRadius: "5px",
                                cursor: "pointer",
                                marginTop: "20px",
                            }}
                        >
                            Register
                        </button>
                    </form>
                </div>
            </main>

            <footer className="page-footer">
                <p>&copy; {new Date().getFullYear()} YourStoryWorld. All rights reserved.</p>
                <nav style={{ marginTop: "10px" }}>
                    <a href="/about" className="footer-link">About Us</a>
                    <a href="/contact" className="footer-link">Contact</a>
                </nav>
            </footer>
        </div>
    );
};

export default RegistrationForm;
